import { css } from '@emotion/react';

export default $ => css`
  .shadow-sm { box-shadow: ${$.boxShadowSm} !important; }
  .shadow { box-shadow: ${$.boxShadow} !important; }
  .shadow-lg { box-shadow: ${$.boxShadowLg} !important; }
  .shadow-none { box-shadow: none !important; }
`;
